/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, take } from 'rxjs';
import { UserInfo } from '../models/entites/userInfo';
import { RegisteredUser } from '../models/entites/registeredUser';
import { environment } from 'src/environments/environment';
import { NotificationHubService } from './notificationHub.service';
import { DialogService } from './dialog.service';
import { SpinnerService } from './spinner.service';
import { Tokens } from '../models/entites/session-storage/tokens';
import { AuthenticationAPI } from '../constants/apiURL';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ActivatedRoute } from '@angular/router';
import { QRCodeHelper } from '../helpers/qrCodeHelper';
import { ROUTES } from '../constants/routes';
const helper: JwtHelperService = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthentificationService {
  constructor(
    private httpClient: HttpClient,
    private notificationHubService: NotificationHubService,
    private dialogService: DialogService,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute
  ) {}

  login(username: string, password: string, rememberMe: boolean): Observable<any> {
    const user = {
      username: username,
      password: password,
      rememberMe: rememberMe
    };

    return this.httpClient.post<any>(environment.baseUrl + AuthenticationAPI.LOGIN, user).pipe(
      map((response) => {
        if (response && response.accessToken) {
          const tokens = new Tokens(response.accessToken, response.refreshToken);
          localStorage.setItem('Tokens', JSON.stringify(tokens));

          const decodedToken = helper.decodeToken(response.accessToken);
          localStorage.setItem('Role', JSON.stringify(decodedToken.role));
          this.dialogService.closeDialog();
          this.spinnerService.hideSpinner();
        }
        return response;
      })
    );
  }

  register(registeredUser: RegisteredUser): Observable<any> {
    return this.httpClient
      .post<UserInfo>(environment.baseUrl + AuthenticationAPI.REGISTER, registeredUser)
      .pipe(map((response) => response));
  }

  hideExpiringMbcNotification(clientId: string) {
    return this.httpClient
      .put<UserInfo>(
        environment.baseUrl + AuthenticationAPI.HIDE_EXPIRING_MBC_NOTIFIACTION,
        clientId
      )
      .pipe(map((response) => response));
  }

  refreshToken(): Observable<any> {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    const refreshRequest = {
      accessToken: this.getAccessToken(),
      refreshToken: this.getRefreshToken(),
      rememberMe: rememberMe
    };

    return this.httpClient
      .post<any>(environment.baseUrl + AuthenticationAPI.REFRESH_TOKEN, refreshRequest)
      .pipe(
        map((response) => {
          if (response && response.accessToken) {
            const tokens = new Tokens(response.accessToken, response.refreshToken);
            localStorage.setItem('Tokens', JSON.stringify(tokens));
            this.dialogService.closeDialog();
            this.spinnerService.hideSpinner();
          }
          return response.accessToken;
        })
      );
  }

  recover(email: string): Observable<any> {
    const user = { email: email };
    return this.httpClient
      .post<any>(environment.baseUrl + AuthenticationAPI.RECOVER, user)
      .pipe(map((response) => response));
  }

  logout() {
    let browserId;
    browserId = localStorage.getItem('browserId');
    let qrCode = localStorage.getItem('QrCodeInfo');
    this.notificationHubService.disconnectFromSignalR();

    if (browserId !== undefined) {
      localStorage.setItem('browserId', browserId!.toString());
    }
    if (qrCode) {
      localStorage.setItem('QrCodeInfo', qrCode!.toString());
    }

    this.spinnerService.hideSpinner();
  }

  getAccessToken() {
    const tokensString = localStorage.getItem('Tokens');
    const tokens = JSON.parse(tokensString!) as Tokens;

    if (tokens == null) {
      return null;
    }
    return tokens.accessToken;
  }

  getRefreshToken() {
    const tokensString = localStorage.getItem('Tokens');
    const tokens = JSON.parse(tokensString!) as Tokens;

    if (tokens == null) {
      return null;
    }
    return tokens.refreshToken;
  }

  storeQrCodeInfoFromUrl() {
    this.activatedRoute.paramMap.pipe(take(1)).subscribe(() => {
      const url = window.location.href.toString().split('?')[1];
      const completeUrl = window.location.href.toString();
      const params = new URLSearchParams(url);
      // this is for scan from outside Loyalty, because DUAL ticket login has # in url
      if (window.location.href.includes('pocetna#')) {
        return;
      }
      if (
        window.location.href.includes(ROUTES.LOGIN) &&
        params.get('modul') &&
        params.get('time')
      ) {
        const qrCodeInfo = QRCodeHelper.GenerateQRCodeInfoBasedOnUrlParams(params, completeUrl);
        localStorage.setItem('QrCodeInfo', JSON.stringify(qrCodeInfo));
      }
    });
  }
}
